import { redeemTokenBaseSchema } from "./shared/creditExchangeSchema.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/creditExchange.ts
const createTransactionInputSchema = z.object({
	partnerId: z.string(),
	jws: z.string()
});
const createTransactionOutputSchema = z.object({
	status: z.string(),
	redeemToken: z.string(),
	redeemUrl: z.string(),
	expiresAt: z.string()
});
const tokenParamSchema = z.object({ token: z.string() });
const tokenSummaryOutputSchema = redeemTokenBaseSchema.pick({
	status: true,
	partnerId: true,
	partnerDeductedAmount: true,
	quotaCurrency: true,
	quotaAmount: true,
	expiresAt: true
});
const redeemOutputSchema = redeemTokenBaseSchema.pick({
	quotaCurrency: true,
	quotaAmount: true
});
const externalTokenStatusInputSchema = z.object({
	partnerId: z.string().min(1).max(64),
	creditExchangeToken: z.string().min(1).max(64)
});
const externalTokenStatusOutputSchema = z.object({
	status: z.enum([
		"created",
		"redeemed",
		"expired"
	]),
	partnerTransactionId: z.string(),
	partnerDeductedAmount: z.number().int(),
	quotaCurrency: z.string(),
	quotaAmount: z.number().int(),
	expiresAt: z.iso.datetime(),
	redeemedAt: z.iso.datetime().nullable()
});
const creditExchangeContract = oc.prefix("/credit-exchange").tag("CreditExchange").router({
	createTransaction: oc.route({
		summary: "Create a credit exchange transaction (partner-facing)",
		method: "POST",
		path: "/external/{partnerId}/transaction"
	}).input(createTransactionInputSchema).output(createTransactionOutputSchema).errors({
		INVALID_SIGNATURE: {
			status: 401,
			message: "JWS signature verification failed"
		},
		INVALID_REQUEST: {
			status: 400,
			message: "Invalid request"
		},
		INSUFFICIENT_DEPOSIT: {
			status: 400,
			message: "Partner deposit balance too low"
		}
	}),
	externalTokenStatus: oc.route({
		summary: "Check redeem token status (partner-facing, S2S)",
		method: "GET",
		path: "/external/{partnerId}/status"
	}).input(externalTokenStatusInputSchema).output(externalTokenStatusOutputSchema).errors({
		INVALID_SECRET: {
			status: 401,
			message: "Shared secret missing or invalid"
		},
		INVALID_REQUEST: {
			status: 400,
			message: "Invalid request"
		},
		TOKEN_NOT_FOUND: {
			status: 404,
			message: "Token not found"
		}
	}),
	tokenSummary: oc.route({
		summary: "Get redeem token summary (user-facing)",
		method: "GET",
		path: "/token/{token}/summary"
	}).input(tokenParamSchema).output(tokenSummaryOutputSchema).errors({
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		TOKEN_NOT_FOUND: {
			status: 404,
			message: "Token not found"
		}
	}),
	redeemToken: oc.route({
		summary: "Redeem a credit exchange token (user-facing)",
		method: "POST",
		path: "/token/{token}/redeem"
	}).input(tokenParamSchema).output(redeemOutputSchema).errors({
		UNAUTHORIZED: {
			status: 401,
			message: "Authentication required"
		},
		TOKEN_NOT_FOUND: {
			status: 404,
			message: "Token not found"
		},
		TOKEN_EXPIRED: {
			status: 410,
			message: "Token has expired"
		},
		TOKEN_ALREADY_REDEEMED: {
			status: 409,
			message: "Token already redeemed"
		}
	})
});
//#endregion
export { creditExchangeContract };
